import { useState } from "react"
import ErrorMessage from "../../../components/ErrorMessage"
import EyeIcon from "../../../assets/images/icons/eye.svg"
import EyeSlashIcon from "../../../assets/images/icons/eye-slash.svg"
import { useTheme } from "../../../contexts/ThemeContext"
import getThemeColors from "../../../utils/getColorTheme"

const Login = ({
  isSingup,
  setIsSingup,
  onSubmit = () => {},
  inputEmailProps = {},
  inputPasswordProps = {},
  clickForgotPassword = () => {},
  errors = [],
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const { addTheme } = useTheme()
  const { theme, background } = getThemeColors(addTheme)

  const isErrorEmail = errors.find(error => error.field === "email")
  const isErrorPassword = errors.find(error => error.field === "password")

  return (
    <div className="auth-form">
      <form
        className="form-login"
        onSubmit={e => {
          e.preventDefault()
          onSubmit()
        }}
      >
        <div className="input-group">
          <div className="group">
            <label htmlFor="email" style={{ color: theme }}>Email *</label>
            <input
              type="text"
              className={`form-control ${isErrorEmail ? "error" : ""}`}
              placeholder="Enter your Email"
              name="email"
              id="email"
              style={{ background: "transparent", color: theme }}
              {...inputEmailProps}
            />
            {isErrorEmail && <ErrorMessage message={isErrorEmail.message} />}
          </div>

          <div className="group">
            <label htmlFor="password" style={{ color: theme }}>Password *</label>
            <div className="input-password-wrapper" style={{ position: "relative", width: "100%" }}>
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${isErrorPassword ? "error" : ""}`}
                placeholder="Enter your Password"
                name="password"
                id="password"
                {...inputPasswordProps}
                style={{ paddingRight: "40px", width: "100%", boxSizing: "border-box", background: "transparent", color: theme }}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <img
                  src={showPassword ? EyeSlashIcon : EyeIcon}
                  alt={showPassword ? "Hide password" : "Show password"}
                  style={{ filter: addTheme === "dark" ? "brightness(0) invert(1)" : "none" }}
                />
              </span>
            </div>
            {isErrorPassword && <ErrorMessage message={isErrorPassword.message} />}
          </div>
        </div>
        <button 
          type="submit" 
          className="btn-main"
          aria-label="Log in to your account"
        >
          Log in
        </button>

        <div className="forgot-password-link">
          <button 
            type="button" 
            onClick={clickForgotPassword}
            aria-label="Go to forgotten password page"
            style={{ color: theme }}
          >
            Forgotten password?
          </button>
        </div>
      </form>
    </div>
  )
}

export default Login
